/**
 * Translates server error messages if they are translation keys
 * @param {string} errorMessage - The error message from the server
 * @param {function} t - The translation function from react-i18next
 * @returns {string} - The translated message or original message if not a translation key
 */
export default function translateServerError(errorMessage, t) {
  // Check if the error message looks like a translation key (starts with 'server.')
  if (typeof errorMessage === 'string' && errorMessage.startsWith('server.')) {
    try {
      // Try to translate using the errors namespace
      const translatedMessage = t(errorMessage, { ns: 'errors' });

      // If translation failed, it returns the key itself, so check if it's different
      if (translatedMessage !== errorMessage) {
        return translatedMessage;
      }
    } catch (e) {
      // If translation fails, fall back to original message
    }
  }

  // Return original message if it's not a translation key or translation failed
  return errorMessage;
}
